import { useState } from 'react';
import Button from '../base/Button';

export default function HotJewelry() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const hotItems = [
    {
      id: 1,
      name: '星河系列钻石项链',
      category: '项链',
      price: '¥89,800',
      originalPrice: '¥108,000',
      discount: '17% OFF',
      image: 'https://public.readdy.ai/ai/img_res/1357d29281618f7e665447728f49049b.jpg',
      badge: '限时特惠',
      rating: 4.9,
      reviews: 128
    },
    {
      id: 2,
      name: '月光石耳环',
      category: '耳环',
      price: '¥32,600',
      originalPrice: '¥38,800',
      discount: '16% OFF',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20moonstone%20earrings%20in%20contemporary%20gallery%20display%20with%20soft%20colorful%20lighting%2C%20modern%20jewelry%20photography%20with%20artistic%20presentation%2C%20museum%20quality%20showcase&width=400&height=400&seq=hot-earrings&orientation=squarish',
      badge: '热销',
      rating: 4.8,
      reviews: 89
    },
    {
      id: 3,
      name: '永恒之爱戒指',
      category: '戒指',
      price: '¥156,000',
      originalPrice: '¥180,000',
      discount: '13% OFF',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20engagement%20ring%20with%20brilliant%20diamond%20in%20modern%20art%20gallery%20setting%2C%20pink%20blue%20and%20teal%20ambient%20lighting%2C%20contemporary%20jewelry%20exhibition%20style%20photography&width=400&height=400&seq=hot-ring&orientation=squarish',
      badge: '新品',
      rating: 5.0,
      reviews: 45
    },
    {
      id: 4,
      name: '海洋之心手链',
      category: '手链',
      price: '¥45,800',
      originalPrice: '¥52,000',
      discount: '12% OFF',
      image: 'https://readdy.ai/api/search-image?query=Ocean%20inspired%20bracelet%20with%20blue%20gemstones%20in%20gallery%20display%20case%2C%20contemporary%20museum%20lighting%20with%20teal%20and%20blue%20accents%2C%20artistic%20jewelry%20photography&width=400&height=400&seq=hot-bracelet&orientation=squarish',
      badge: '推荐',
      rating: 4.7,
      reviews: 156
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % hotItems.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + hotItems.length) % hotItems.length);
  };

  return (
    <section className="py-24 bg-white" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <div className="flex space-x-2 mb-6">
              <div className="w-12 h-1 bg-pink-400"></div>
              <div className="w-12 h-1 bg-blue-400"></div>
              <div className="w-12 h-1 bg-teal-400"></div>
            </div>
          </div>
          <h2 className="text-5xl font-light text-gray-800 mb-6 tracking-wide">TRENDING NOW</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-light leading-relaxed">
            当季热门艺术珠宝，限时特惠价格
          </p>
        </div>

        {/* Hot Items Carousel */}
        <div className="relative">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {hotItems.map((item, index) => (
              <div 
                key={item.id} 
                className={`bg-gradient-to-br from-gray-50 to-white border border-gray-100 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-500 group ${
                  index === currentSlide ? 'ring-2 ring-pink-400' : ''
                }`}
              >
                <div className="relative">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  
                  {/* Badges */}
                  <div className="absolute top-4 left-4">
                    <span className="bg-gradient-to-r from-pink-400 via-blue-400 to-teal-400 text-white px-3 py-1 rounded-full text-sm font-light shadow-lg">
                      {item.badge}
                    </span>
                  </div>
                  
                  <div className="absolute top-4 right-4">
                    <span className="bg-red-500 text-white px-3 py-1 rounded-full text-sm font-light shadow-lg">
                      {item.discount}
                    </span>
                  </div>
                  
                  <button className="absolute bottom-4 right-4 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center text-gray-600 hover:text-pink-500 transition-colors cursor-pointer">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-heart-line"></i>
                    </div>
                  </button>
                </div>
                
                <div className="p-6">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm text-gray-500 font-light">{item.category}</span>
                    <div className="flex items-center">
                      <div className="w-4 h-4 flex items-center justify-center text-yellow-400 mr-1">
                        <i className="ri-star-fill text-xs"></i>
                      </div>
                      <span className="text-sm text-gray-600 font-light">{item.rating}</span>
                      <span className="text-sm text-gray-400 font-light ml-1">({item.reviews})</span>
                    </div>
                  </div>
                  
                  <h3 className="text-lg font-light text-gray-800 mb-4 tracking-wide">{item.name}</h3>
                  
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <span className="text-2xl font-light text-gray-800">{item.price}</span>
                      <span className="text-sm text-gray-400 line-through ml-2 font-light">{item.originalPrice}</span>
                    </div>
                  </div>
                  
                  <Button variant="primary" size="sm" className="w-full">
                    <span className="mr-1">立即购买</span>
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-shopping-cart-line"></i>
                    </div>
                  </Button>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          <button 
            onClick={prevSlide}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-gray-600 hover:text-pink-500 transition-colors cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line"></i>
            </div>
          </button>
          
          <button 
            onClick={nextSlide}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-gray-600 hover:text-pink-500 transition-colors cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </button>
        </div>

        {/* Slide Indicators */}
        <div className="flex justify-center mt-8 space-x-2">
          {hotItems.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                currentSlide === index
                  ? 'bg-gradient-to-r from-pink-400 via-blue-400 to-teal-400'
                  : 'bg-gray-300 hover:bg-gray-400'
              }`}
            />
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-12">
          <Button variant="outline" size="lg">
            <span className="mr-2">查看全部热门商品</span>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Button>
        </div>
      </div>
    </section>
  );
}
